import React, { Component, Fragment } from 'react';
import { string, func } from 'prop-types';
import { ReactComponent as CreativeIcon } from 'src/images/creative-view.svg'
import { ReactComponent as CreativeBlueIcon } from 'src/images/creative-view-blue.svg'
import { ReactComponent as TableIcon } from 'src/images/table-view.svg'
import { ReactComponent as TableBlueIcon } from 'src/images/table-view-blue.svg'
import { Button } from 'src/components/shared'

export default class HeaderViewsToggle extends Component {

  render() {
    const { onViewModeChange, viewMode } = this.props

    return (
      <Fragment>

        <Button
          onClick={onViewModeChange('table')}
          className={viewMode === 'table' ? `view_active` : ''}
        >
          {viewMode === 'creative' ? <TableIcon /> : <TableBlueIcon />}
        </Button>

        <Button
          onClick={onViewModeChange('creative')}
          className={viewMode === 'creative' ? `view_active` : ''}
        >
          {viewMode === 'creative' ? <CreativeBlueIcon /> : <CreativeIcon />}
        </Button>

      </Fragment>
    )
  }
}

HeaderViewsToggle.propTypes = {
  onViewModeChange: func,
  viewMode: string
};

HeaderViewsToggle.defaultProps = {
  onViewModeChange: () => { },
  viewMode: 'table'
};


